import { render, staticRenderFns } from "./SortedSelect.vue?vue&type=template&id=21b6afb5&"
import script from "./SortedSelect.vue?vue&type=script&lang=js&"
export * from "./SortedSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports